import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useFormik } from "formik";
import { Form, Button, Image, Row, Col, Spinner } from "react-bootstrap";
import * as Yup from "yup";
import { FaUserCircle } from "react-icons/fa";
import { get_user } from "../actions/myuser";
import axios from "axios";

function Profile({ user, get_user }) {
  console.log(user);
  const [updating, setUpdating] = useState(false);
  const formik = useFormik({
    initialValues: {
      first_name: user.first_name || "",
      last_name: user.last_name || "",
      phone_no: user.phone_no || "",
      profile_pic: null,
    },
    validationSchema: Yup.object({
      first_name: Yup.string().required("First name is required"),
      last_name: Yup.string().required("Last name is required"),
      phone_no: Yup.string()
        .matches(/^\d{9}$/, "Phone number must be 9 digits")
        .required("Phone number is required"),
    }),
    onSubmit: async (values) => {
      setUpdating(true);
      const formData = new FormData();
      formData.append("first_name", values.first_name);
      formData.append("last_name", values.last_name);
      formData.append("phone_no", values.phone_no);
      if (values.profile_pic) {
        formData.append("profile_pic", values.profile_pic);
      }

      try {
        const response = await axios.patch(
          `${process.env.REACT_APP_API_URL}/ticketing/update_profile`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `JWT ${localStorage.getItem("access")}`,
            },
          }
        );
        console.log("Profile updated successfully:", response.data);
        setUpdating(false);
      } catch (error) {
        console.error("Error updating profile:", error);
        setUpdating(false);
      }
    },
  });

  useEffect(() => {
    get_user()
      .then((res) => {})
      .catch((err) => {});
  }, [updating]);

  return (
    <Row>
      <div className="pagetitle mb-4">
        <h1 className="title">Profile</h1>
      </div>
      <div>
        <Form onSubmit={formik.handleSubmit}>
          <Row className="mb-3">
            <Col xs={12} md={4} className="text-center">
              {user.profile_pic ? (
                <Image
                  src={`${process.env.REACT_APP_API_URL}${user.profile_pic}`}
                  alt="Profile"
                  roundedCircle
                  width={150}
                  height={150}
                />
              ) : (
                <FaUserCircle size={150} color="grey" />
              )}
              <Form.Group controlId="formFile" className="mt-3">
                <Form.Label>Change Profile Picture</Form.Label>
                <Form.Control
                  type="file"
                  onChange={(event) => {
                    formik.setFieldValue(
                      "profile_pic",
                      event.currentTarget.files[0]
                    );
                  }}
                />
              </Form.Group>
            </Col>
            <Col xs={12} md={8}>
              <Form.Group className="mb-3" controlId="email">
                <Form.Label>Email</Form.Label>
                <Form.Control type="email" value={user.email} disabled />
              </Form.Group>

              <Form.Group className="mb-3" controlId="first_name">
                <Form.Label>First Name</Form.Label>
                <Form.Control
                  type="text"
                  name="first_name"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.first_name}
                  isInvalid={
                    formik.touched.first_name && !!formik.errors.first_name
                  }
                />
                <Form.Control.Feedback type="invalid">
                  {formik.errors.first_name}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-3" controlId="last_name">
                <Form.Label>Last Name</Form.Label>
                <Form.Control
                  type="text"
                  name="last_name"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.last_name}
                  isInvalid={
                    formik.touched.last_name && !!formik.errors.last_name
                  }
                />
                <Form.Control.Feedback type="invalid">
                  {formik.errors.last_name}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-3" controlId="phone_no">
                <Form.Label>Phone Number</Form.Label>
                <Form.Control
                  type="text"
                  name="phone_no"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.phone_no}
                  isInvalid={
                    formik.touched.phone_no && !!formik.errors.phone_no
                  }
                />
                <Form.Control.Feedback type="invalid">
                  {formik.errors.phone_no}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
          <div className="d-flex justify-content-center">
            <Button variant="dark" type="submit" disabled={updating}>
              {updating ? (
                <>
                  <Spinner as="span" variant="border" size="sm" />
                </>
              ) : (
                <>Update</>
              )}
            </Button>
          </div>
        </Form>
      </div>
    </Row>
  );
}

const mapStateToProps = (state) => ({
  user: state.current_user.user,
});

export default connect(mapStateToProps, {
  get_user,
})(Profile);
